import React, { Component } from "react"
import { dataMptsSelectorsPrototype, dataMptsSelectorsSekans, dataMptsSelectorsXowopo } from "../../data"
import { noContextMenu } from "../../logic/DOMElementsRelated"
import NavBar from "../NavBar/NavBar.js"
import './mptsSelector.css'
import { MptsSelectorCategories } from "./MptsSelectorCategories.js"

class MptsSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      xopowoContainerVisible: true,
      prototypeContainerVisible: false,
      sekansContainerVisible: true,
    }

    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    noContextMenu()
  }

  handleClick(event) {
    switch(event.target.dataset.id) {
      case "xopowo": 
        if (!this.state.xopowoContainerVisible) this.toggleActiveCategorie("xopowo")
        break

      case "prototype": 
      if (!this.state.prototypeContainerVisible) this.toggleActiveCategorie("prototype")
        break  
        
      case "sekans": 
      if (!this.state.sekansContainerVisible) this.toggleActiveCategorie("sekans")
        break  

      default: break
    }
  }

  toggleActiveCategorie(toVisible) {
    let xopowoContainerVisible = false
    let prototypeContainerVisible = false
    let sekansContainerVisible = false

    switch(toVisible) {
      case "xopowo":
        xopowoContainerVisible = true
        break

      case "prototype":
        prototypeContainerVisible = true
        break

      case "sekans":
        sekansContainerVisible = true
        break

      default: break
    }

    this.setState({xopowoContainerVisible: xopowoContainerVisible, prototypeContainerVisible: prototypeContainerVisible, sekansContainerVisible: sekansContainerVisible})
  }

  render() {
    const xopowoCategorieClassName = this.state.xopowoContainerVisible ? "modelTitle titleBlack pointerHover" : "modelTitle titleGrey pointerHover"
    const prototypeCategorieClassName = this.state.prototypeContainerVisible ? "modelTitle titleBlack lastModelTitle pointerHover lastModelTitle" : "modelTitle titleGrey lastModelTitle pointerHover"
    const sekansCategorieClassName = this.state.sekansContainerVisible ? "modelTitle titleBlack pointerHover" : "modelTitle titleGrey pointerHover"

    return (
      <React.Fragment>
        <NavBar />
        <div className="blank-marge"></div>
        <div className="overflowYContainer">
          <div className="categoriesContainer">
            <div className="modelType">
              Model &nbsp;&nbsp;
            </div>
            <div className={xopowoCategorieClassName} data-id="xopowo">
              X0P0W0
            </div>
          </div>
          <MptsSelectorCategories data={dataMptsSelectorsXowopo} containerVisible={this.state.xopowoContainerVisible} />

          <div className="categoriesContainer">
            <div className="modelType">
              Model &nbsp;&nbsp;
            </div>
            <div className={sekansCategorieClassName} data-id="sekans">
              Sekans
            </div>
          </div>
          <MptsSelectorCategories data={dataMptsSelectorsSekans} containerVisible={this.state.sekansContainerVisible} />

          <div className="categoriesContainer hidden">
            <div className="modelType">
              Model &nbsp;&nbsp;
            </div>
            <div className={prototypeCategorieClassName} data-id="prototype">
              Prototype
            </div>
          </div>
          <MptsSelectorCategories data={dataMptsSelectorsPrototype} containerVisible={this.state.prototypeContainerVisible} />
          
        </div>
      </React.Fragment>  
    )
  }
}

export default MptsSelector